import LaunchIcon from "@mui/icons-material/Launch";
import { Box, Button, Stack, Tooltip, Typography } from "@mui/material";

import {
  EVOTRUX_BRAND_GREEN,
  EVOTRUX_BRAND_GREEN_HOVER,
  EVOTRUX_NAVY,
} from "constants/index";

const EVOTRUX_HOMEPAGE_URL = "https://evotrux.com";
const EVOTRUX_SIGN_IN_URL = "https://v2.evotrux.com/";
const EVOTRUX_BOOK_DEMO_URL =
  "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2q_WBxc2x4hOcQMVFUsu1QEa7_8xG4KnihHcGRpC4XdG1K7k0ellP4rYl4Qub5m-I3aKCsRoHR";
const EVOTRUX_WORDMARK_PATH =
  "M90.5 18.653c-.323 0-.553-.053-.662-.146-.108-.094-.175-.294-.175-.6V9.68h5.758v-4.6h-5.758V0h-6.975v17.68c0 2.44.46 4.08 1.379 4.893.919.827 2.703 1.227 5.366 1.227h6.745v-5.16h-5.677v.013zm75.254 5.16l-4.961-5.533-5.083 5.533h-8.948l9.624-9.64-9.016-9.08h9.138l4.542 5.054 4.542-5.054h8.827l-9.057 9.08 9.624 9.64h-9.232zm-38.282 0c-2.582 0-4.366-.386-5.38-1.16-1.014-.773-1.514-2.306-1.514-4.6V5.08h6.975v12.827c0 .293.054.493.176.6.108.093.338.146.662.146h8.719V5.08h7.016v18.733h-16.654zm-25.386 0V10.88c0-2.373.473-3.92 1.419-4.667.946-.746 2.717-1.12 5.326-1.12h7.881v5.08h-6.678c-.351 0-.581.04-.703.134-.108.093-.176.28-.176.573v12.933h-7.069zM70.427 10.467c0-.294-.054-.494-.176-.6-.108-.094-.338-.147-.662-.147h-9.516c-.325 0-.555.053-.676.147-.122.093-.19.293-.19.6v7.626c0 .294.068.494.19.6.121.094.351.147.676.147h9.516c.325 0 .554-.053.662-.147.109-.093.176-.293.176-.6v-7.626zM59.127 24c-2.61 0-4.407-.387-5.394-1.147-1-.76-1.5-2.293-1.5-4.613v-7.587c0-2.32.5-3.853 1.5-4.613 1-.76 2.798-1.133 5.393-1.133h11.369c2.595 0 4.406.373 5.393 1.133 1 .76 1.5 2.293 1.5 4.613v7.587c0 2.32-.5 3.853-1.5 4.613-.987.76-2.784 1.147-5.393 1.147H59.126zm-23.846-.187L24.67 5.08h7.921l3.258 6.36c.081.147.716 1.52 1.933 4.107.635-1.547 1.244-2.894 1.852-4.04l3.298-6.427h7.732L40.012 23.813h-4.73zm-18.343-13.68c0-.293-.054-.493-.176-.6-.108-.093-.338-.146-.662-.146H7.462c-.325 0-.554.053-.663.146-.108.094-.162.294-.162.6v2.614h10.314v-2.614h-.013zM6.935 23.813c-2.596 0-4.407-.373-5.421-1.133C.5 21.907 0 20.387 0 18.093v-7.48C0 8.32.5 6.8 1.514 6.04c1.014-.76 2.812-1.133 5.42-1.133h9.544c2.609 0 4.42.373 5.461 1.12 1.041.746 1.555 2.266 1.555 4.56v5.866H6.637v1.987c0 .28.054.453.176.547.108.093.338.133.662.133h15.64v4.707H6.935v-.014z";

export function PublicShipmentMarketingHeader() {
  return (
    <Box
      component="header"
      sx={{
        bgcolor: EVOTRUX_NAVY,
        height: 64,
        px: { xs: 2, md: 3 },
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Tooltip title="Evotrux homepage (opens in a new tab)">
        <Box
          component="a"
          href={EVOTRUX_HOMEPAGE_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Evotrux"
          sx={{
            flexShrink: 0,
            display: "inline-flex",
            alignItems: "center",
            color: EVOTRUX_BRAND_GREEN,
            textDecoration: "none",
          }}
        >
          <Box
            component="svg"
            width="175"
            height="24"
            viewBox="0 0 175 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ height: 24, width: "auto", display: "block" }}
          >
            <path d={EVOTRUX_WORDMARK_PATH} fill="currentColor" />
          </Box>
        </Box>
      </Tooltip>

      <Box
        sx={{
          display: { xs: "none", md: "block" },
          flexGrow: 1,
          textAlign: "center",
          px: 2,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        <Typography
          component="span"
          sx={{ color: "common.white", fontSize: "0.875rem" }}
        >
          <Box
            component="strong"
            sx={{ color: EVOTRUX_BRAND_GREEN, fontWeight: 600 }}
          >
            Logistics, Fixed.
          </Box>
          {" — modern shipment visibility for carriers & shippers"}
        </Typography>
      </Box>

      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{ flexShrink: 0 }}
      >
        <Tooltip title="Sign in to Evotrux (opens in a new tab)">
          <Button
            component="a"
            href={EVOTRUX_SIGN_IN_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant="text"
            endIcon={<LaunchIcon fontSize="small" />}
            sx={{
              color: "common.white",
              fontWeight: 500,
              fontSize: "0.875rem",
              textTransform: "none",
              display: { xs: "none", sm: "inline-flex" },
              "&:hover": { bgcolor: "rgba(255, 255, 255, 0.08)" },
            }}
          >
            Sign in
          </Button>
        </Tooltip>
        <Tooltip title="Book a product demo (opens in a new tab)">
          <Button
            component="a"
            href={EVOTRUX_BOOK_DEMO_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            endIcon={<LaunchIcon fontSize="small" />}
            sx={{
              bgcolor: EVOTRUX_BRAND_GREEN,
              color: "common.white",
              fontWeight: 600,
              fontSize: "0.875rem",
              textTransform: "none",
              boxShadow: "none",
              px: 2,
              py: 1,
              "&:hover": {
                bgcolor: EVOTRUX_BRAND_GREEN_HOVER,
                boxShadow: "none",
              },
            }}
          >
            Book Demo
          </Button>
        </Tooltip>
      </Stack>
    </Box>
  );
}
